import React, { useEffect, useState } from 'react';
import './RateTable.css';
import RoomOrderModel from './RoomOrderModel'; // Import RateModel component
import apiService from '../../api/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from '../Pagination/Pagination';
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import { getRoomNumberById } from '../../utils';

const RoomOrderTable = ({
  rooms,
  data,
  setData,
  guests,
  inventory,
  hotelId,
}) => {
  const [editingItem, setEditingItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    id: null,
  });

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const response = await apiService.get(`/bookings/?hotel=${hotelId}`);
      setBookings(response);
    } catch (error) {
      console.log(error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Array.isArray(data)
    ? data
        .slice() // avoid mutating original array
        .sort((a, b) => new Date(b.order_date) - new Date(a.order_date)) // latest first
        .slice(indexOfFirstRow, indexOfLastRow)
    : [];

  const totalPages = Math.max(Math.ceil(data.length / rowsPerPage), 1);

  // Handle Edit Button Click (Opens Modal)
  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  // Handle Save from Modal
  const handleEdit = updatedItem => {
    setData(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const confirmDelete = id => {
    if (!id) return;
    setDeleteConfirm({ isOpen: true, id });
  };

  const handleDelete = async () => {
    try {
      const response = await apiService.patch(
        `/room-orders/${deleteConfirm.id}/?hotel=${hotelId}`,
        {
          is_archive: true,
        }
      );
      toast.error('Room order deleted successfully!');
      setData(prevData =>
        prevData.filter(item => item.id !== deleteConfirm.id)
      );
    } catch (err) {
      console.log(err);
    } finally {
      setDeleteConfirm({ isOpen: false });
    }
  };

  // Format date for better readability
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleString(); // Adjust format as needed
  };

  const getGuestName = guestBookingId => {
    const booking = bookings.find(b => b.id === guestBookingId);
    if (!booking) {
      return 'Unknown';
    }

    const guestId = booking.guest;
    const guest = guests.find(g => g.id === guestId);
    if (!guest) {
      return 'Unknown';
    }

    return guest.name;
  };

  const getOrderName = inventoryId => {
    const orderName = inventory.find(item => item.id === inventoryId);
    if (!orderName) {
      return 'Unknown';
    }
    return orderName.item_name;
  };
  let roomNumber = bookings.find(b => b.id === data.booking) || 'Unknown';

  return (
    <>
      <div className="room-table-container" style={{ minHeight: '300px' }}>
        <table className="rate-table ">
          <thead>
            <tr>
              <th>Room Number</th>
              <th>Order</th>
              <th>Order Details</th>
              <th>Order Date</th>
              <th>Quantity</th>
              <th>Amount</th>
              {/* <th>Booking ID</th>
              <th>Inventory ID</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map(item => (
                <tr key={item.id}>
                  {/* <td>
                    {bookings
                      .find(booking => booking.id === item.booking)
                      ?.room?.map(r => r.room_number)
                      .join(', ') || 'N/A'}
                  </td> */}
                  <td>{getRoomNumberById(rooms, item.room)}</td>
                  <td>{getOrderName(item.inventory)}</td>
                  <td>
                    {item.order_details.charAt(0).toUpperCase() +
                      item.order_details.slice(1)}
                  </td>

                  <td>{formatDate(item.order_date)}</td>
                  <td>{item.quantity}</td>
                  <td>{item.amount}</td>
                  {/* <td>{item.booking}</td> */}
                  {/* <td>{item.inventory}</td> */}
                  <td>
                    <div className="options-menu">
                      <button className="options-button">⋮</button>
                      <div className="dropdown-menu">
                        <button onClick={() => handleEditClick(item)}>
                          Edit
                        </button>
                        <button onClick={() => confirmDelete(item.id)}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <>
        {isModalOpen && (
          <RoomOrderModel
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleEdit}
            existingData={editingItem}
            hotelId={hotelId}
          />
        )}

        {deleteConfirm.isOpen && (
          <ConfirmDeleteModal
            isOpen={deleteConfirm.isOpen}
            onConfirm={handleDelete}
            onCancel={() => setDeleteConfirm({ isOpen: false, id: null })}
            message="Are you sure you want to delete this room order?"
          />
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </>
    </>
  );
};

export default RoomOrderTable;
